export default "__VITE_ASSET__8LBdfgil__"